import React from 'react'
import styled from 'styled-components'
import { Dialog } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import IconButton from '@material-ui/core/IconButton'
import { useHistory } from 'react-router-dom'

export type ContentAccessDialogProps = {
  open: boolean
  onClose: () => void
  doorId: string
  roomId: number
  type: 'login' | 'plan'
  callBackUrl: string
}

const messages = {
  'login': '記事を読むにはログインが必要です',
  'plan': '記事を読むにはプランへの参加が必要です',
}

const buttonMessages = {
  'login': 'ログインする',
  'plan': 'プランを選択する',
}

export const ContentAccessDialog: React.FC<ContentAccessDialogProps> = ({
  open,
  onClose,
  doorId,
  roomId,
  type,
  callBackUrl,
}) => {
  const history = useHistory()
  const message = messages[type]
  const buttonMessage = buttonMessages[type]

  const onClickHandler = () => {
    history.push(
      type === 'plan'
        ? `/door/${doorId}/plans?room=${roomId}`
        : { pathname: '/signin', state: { redirect: callBackUrl } }
    )
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="error-dialog-title"
      aria-describedby="error-dialog-description"
      fullWidth
      maxWidth={false}
      PaperProps={{
        style: {
          width: '80%',
          maxWidth: '570px',
          borderRadius: '12px',
          padding: '40px 40px',
          textAlign: 'center',
          position: 'relative',
        }
      }}
    >
      <ContentAccessDialogWrapper>
        <CloseIcon onClick={onClose}>
          <Cancel />
        </CloseIcon>
        <Title>{message}</Title>
        <ActionButton onClick={onClickHandler}>
          {buttonMessage}
        </ActionButton>
      </ContentAccessDialogWrapper>
    </Dialog>
  )
}

const ContentAccessDialogWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 100%;
`

const Title = styled.h2`
    font-size: 18px;
    color: #333;
    font-weight: bold;
    margin-bottom: 40px;
`

const ActionButton = styled.button`
    width: 100%;
    max-width: 230px;
    height: 48px;
    border-radius: 24px;
    background: linear-gradient(140deg, rgb(25, 152, 208) 0%, rgb(102, 242, 210) 100%);
    color: #ffffff;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    transition: 0.3s ease;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    margin-top: auto;

    &:hover {
        background: #ffffff;
        color: rgb(25, 152, 208);
        box-shadow: 0 4px 24px rgba(107, 133, 141, 0.16);
    }
`

const CloseIcon = styled(IconButton)`
    position: absolute;
    right: 4px;
    top: 4px;
`
